/**
 * Base58 characters must ONLY include `123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz`
 * @kind namespace
 * @name base58_chars
 * @type {string}
 */
const base58_chars =
  '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz'

module.exports = base58_chars
